/* eslint-disable no-unused-vars */
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import * as api from './constants/api';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Auth0ProviderWithHistory from './auth/Auth0ProviderWithHistory';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { LoadingProvider } from 'hooks';

if (
  window.location.pathname !== '/logout' &&
  window.location.pathname !== '/session' &&
  window.location.pathname !== '/unauthorized' &&
  window.location.pathname !== '/error'
) {
  localStorage.setItem('redirectUrl', window.location.pathname);
}

// Create a client
const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <LoadingProvider>
            <App />
          </LoadingProvider>
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </Provider>
    <ReactQueryDevtools />
  </QueryClientProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
